module.exports = __webpack_public_path__ + "static/media/7_l_molbert_3.13_54.07.b5210ba8.png";